export const key = "AIzaSyCYImCm4bH5j0Uc-oTqTd5bphdznFpJPxQ";
export const cx = "52add6cada27d4567";